import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';

const EventDetailsForm = ({ formData, onChange, errors }) => {
  const occasionTypes = [
    { value: 'casual', label: 'Casual Dinner' },
    { value: 'birthday', label: 'Birthday Celebration' },
    { value: 'anniversary', label: 'Anniversary' },
    { value: 'holiday', label: 'Holiday Gathering' },
    { value: 'business', label: 'Business Dinner' },
    { value: 'family', label: 'Family Reunion' },
    { value: 'friends', label: 'Friends Gathering' },
    { value: 'other', label: 'Other' }
  ];

  const durationOptions = [
    { value: '2', label: '2 hours' },
    { value: '3', label: '3 hours' },
    { value: '4', label: '4 hours' },
    { value: '5', label: '5 hours' },
    { value: '6', label: '6+ hours' }
  ];

  const handleInputChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Event Details</h3>
      <div className="space-y-4">
        <Input
          label="Event Title"
          type="text"
          placeholder="Enter event title"
          value={formData?.title || ''}
          onChange={(e) => handleInputChange('title', e?.target?.value)}
          error={errors?.title}
          required
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            label="Date"
            type="date"
            value={formData?.date || ''}
            onChange={(e) => handleInputChange('date', e?.target?.value)}
            error={errors?.date}
            required
            min={new Date()?.toISOString()?.split('T')?.[0]}
          />

          <Input
            label="Time"
            type="time"
            value={formData?.time || ''}
            onChange={(e) => handleInputChange('time', e?.target?.value)}
            error={errors?.time}
            required
          />
        </div>

        <Input
          label="Location"
          type="text"
          placeholder="Enter dinner location"
          value={formData?.location || ''}
          onChange={(e) => handleInputChange('location', e?.target?.value)}
          error={errors?.location}
          required
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Select
            label="Occasion Type"
            options={occasionTypes}
            value={formData?.occasionType || ''}
            onChange={(value) => handleInputChange('occasionType', value)}
            placeholder="Select occasion type"
            error={errors?.occasionType}
          />

          <Select
            label="Expected Duration"
            options={durationOptions}
            value={formData?.duration || ''}
            onChange={(value) => handleInputChange('duration', value)}
            placeholder="Select duration"
            error={errors?.duration}
          />
        </div>

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">Special Notes</label>
          <textarea
            className="w-full min-h-[100px] px-3 py-2 border border-border rounded-lg bg-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-vertical"
            placeholder="Add any special notes, themes, or requirements for this dinner..."
            value={formData?.notes || ''}
            onChange={(e) => handleInputChange('notes', e?.target?.value)}
          />
        </div>

        <div className="space-y-3">
          <label className="text-sm font-medium text-foreground">Advanced Options</label>
          
          <Checkbox
            label="Send calendar invitations to guests"
            checked={formData?.sendInvitations || false}
            onChange={(e) => handleInputChange('sendInvitations', e?.target?.checked)}
          />

          <Checkbox
            label="Enable automatic reminders"
            checked={formData?.enableReminders || false}
            onChange={(e) => handleInputChange('enableReminders', e?.target?.checked)}
          />

          <Checkbox
            label="Allow guests to suggest dishes"
            checked={formData?.allowSuggestions || false}
            onChange={(e) => handleInputChange('allowSuggestions', e?.target?.checked)}
          />
        </div>
      </div>
    </div>
  );
};

export default EventDetailsForm;